import { KeycloakConfig } from "keycloak-js";

const keycloakKonfig: KeycloakConfig = {
  url: process.env.https://auth.dev.beg-verwaltung.de as string,
  realm: process.env.beg as string,
  clientId: process.env.beg-dahtest-portal as string
}

export default keycloakKonfig;